namespace SPA
{
	export namespace gui
	{
		export namespace Address
		{
			export function PostalAddressNormalized( address: Wollmilch.PostalAddressObject ): ui.base.BaseHTMLElement
			{
				return new ui.base.BaseHTMLElement( 'address' ).text( address.display );
			}

			export function PostalAddress( address: Wollmilch.PostalAddressObject ): ui.base.BaseHTMLElement
			{
				return new ui.base.BaseHTMLElement( 'address' )
					.append( ui.$$.span().text( address.Street + ' ' + address.HouseNumber ) )
					.append( ui.$$.br() )
					.append( ui.$$.span().text( address.PostalCode + ' ' + address.City ) )
					.append( ui.$$.br() )
					.append( ui.$$.span().text(
						( address.State ? '(' + address.State + ')' : '' ) +
						( address.State && address.Country ? ' ' : '' ) +
						( address.Country ? address.Country : '' ) )
					);
			}

			export function PostalAddressNormalizedWithMap( address: Wollmilch.PostalAddressObject ): ui.base.BaseHTMLElement
			{
				const map = ui.$$.div();

				// buildMap( map, address );

				return new ui.base.BaseHTMLElement( 'div' )
					.append( PostalAddressNormalized( address ) )
					.append( map );
			}

			export function PostalAddressWithMap( address: Wollmilch.PostalAddressObject ): ui.base.BaseHTMLElement
			{
				const map = ui.$$.div();

				// buildMap( map, address );

				return new ui.base.BaseHTMLElement( 'div' )
					.append( PostalAddress( address ) )
					.append( map );
			}

			// function buildMap( map: JQuery, address: Wollmilch.PostalAddressObject ): void
			// {
			// 	map.css(
			// 		{
			// 			"width": '100%',
			// 			"height": '400px',
			// 			'background-color': '#555',
			// 			'text-align': 'center',
			// 			'vertical-align': 'middle',
			// 			'font-size': '30px',
			// 			"color": '#777'
			// 		}
			// 	).text( 'LOADING MAP' );
			//
			// 	const promise = new Promise(
			// 		(resolve, reject) =>
			// 		{
			// 			new google.maps.Geocoder().geocode(
			// 				{ address: address.display },
			// 				( results, status ) =>
			// 				{
			// 					if ( status === google.maps.GeocoderStatus.OK )
			// 					{
			// 						resolve( results[ 0 ] );
			// 					}
			// 				}
			// 			);
			// 		}
			// 	);
			//
			// 	setTimeout(
			// 		() =>
			// 		{
			// 			// derzeit Geokoordinaten der GSD
			// 			const maps: google.maps.Map = new google.maps.Map(
			// 				map[ 0 ],
			// 				{
			// 					fullscreenControl: false,
			// 					keyboardShortcuts: false,
			// 					signInControl: false,
			// 					mapTypeId: google.maps.MapTypeId.HYBRID
			// 				}
			// 			);
			//
			// 			promise.then(
			// 				// @ts-ignore
			// 				( result: google.maps.GeocoderResult ) =>
			// 				{
			// 					maps.setZoom( 18 );
			// 					maps.setCenter( result.geometry.location );
			//
			// 					const marker = new google.maps.Marker( { position: result.geometry.location, map: maps } );
			// 					marker.setAnimation( google.maps.Animation.DROP );
			//
			// 					maps.panTo( result.geometry.location );
			// 				}
			// 			);
			// 		},
			// 		1000
			// 	);
			// }
		}
	}
}
